// Rivers card game data - ranked by river discharge (water volume)
export const RIVERS_CARDS = [
  { id: 1, name: "Amazon", rank: 1, image: "/images/rivers/rivers_1.jpg" },
  { id: 2, name: "Ganges", rank: 2, image: "/images/rivers/rivers_2.jpg" },
  { id: 3, name: "Congo", rank: 3, image: "/images/rivers/rivers_3.jpg" },
  { id: 4, name: "Orinoco", rank: 4, image: "/images/rivers/rivers_4.jpg" },
  { id: 5, name: "Yangtze", rank: 5, image: "/images/rivers/rivers_5.jpg" },
  { id: 6, name: "Rio de la Plata", rank: 6, image: "/images/rivers/rivers_6.jpg" },
  { id: 7, name: "Mississippi", rank: 7, image: "/images/rivers/rivers_7.jpg" },
  { id: 8, name: "Yenisei", rank: 8, image: "/images/rivers/rivers_8.jpg" },
  { id: 9, name: "Lena", rank: 9, image: "/images/rivers/rivers_9.jpg" },
  { id: 10, name: "St. Lawrence", rank: 10, image: "/images/rivers/rivers_10.jpg" },
  { id: 11, name: "Mekong", rank: 11, image: "/images/rivers/rivers_11.jpg" },
  { id: 12, name: "Irrawaddy", rank: 12, image: "/images/rivers/rivers_12.jpg" },
  { id: 13, name: "Ob", rank: 13, image: "/images/rivers/rivers_13.jpg" },
  { id: 14, name: "Amur", rank: 14, image: "/images/rivers/rivers_14.jpg" },
  { id: 15, name: "Tocantins", rank: 15, image: "/images/rivers/rivers_15.jpg" },
  { id: 16, name: "Pearl", rank: 16, image: "/images/rivers/rivers_16.jpg" },
  { id: 17, name: "Mackenzie", rank: 17, image: "/images/rivers/rivers_17.jpg" },
  { id: 18, name: "Volga", rank: 18, image: "/images/rivers/rivers_18.jpg" },
  { id: 19, name: "Magdalena", rank: 19, image: "/images/rivers/rivers_19.jpg" },
  { id: 20, name: "Niger", rank: 20, image: "/images/rivers/rivers_20.jpg" },
  { id: 21, name: "Columbia", rank: 21, image: "/images/rivers/rivers_21.jpg" },
  { id: 22, name: "Fly", rank: 22, image: "/images/rivers/rivers_22.jpg" },
  { id: 23, name: "Yukon", rank: 23, image: "/images/rivers/rivers_23.jpg" },
  { id: 24, name: "Salween", rank: 24, image: "/images/rivers/rivers_24.jpg" },
  { id: 25, name: "Danube", rank: 25, image: "/images/rivers/rivers_25.jpg" },
  { id: 26, name: "Kapuas", rank: 26, image: "/images/rivers/rivers_26.jpg" },
  { id: 27, name: "Indus", rank: 27, image: "/images/rivers/rivers_27.jpg" },
  { id: 28, name: "Mamberamo", rank: 28, image: "/images/rivers/rivers_28.jpg" },
  { id: 29, name: "Sepik", rank: 29, image: "/images/rivers/rivers_29.jpg" },
  { id: 30, name: "Essequibo", rank: 30, image: "/images/rivers/rivers_30.jpg" }
];
